import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
	NavLink
} from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { createUseStyles } from 'react-jss'
import { Result, SpinLoading, Popup, Avatar, List } from 'antd-mobile';
import { useParams } from 'react-router-dom';
import { pushStateHistoryModal, POST, TranslateContext, useAuth, useNavigation, UserConfigContext, UserContext, useTranslateContext, useUserConfigContext, useUserContext, ycStorage, LanguageContext } from 'fennec-ui';
import moment from 'moment-timezone';
import 'moment/locale/ru';

// --- mobile --- 
import PaymentForm from '../../forms/PaymentForm'
import PaymentPreview from '../../forms/PaymentPreview'
// ---  ---  --- 

// 
import './index.less';

import CRUDE_VseTipiPolzovatelei from '../../../objects/VseTipiPolzovatelei/crude'
import { errorCatch, GET, IfElse, QueryDetail, READWITH } from 'fennec-ui';
import { Action } from 'fennec-ui'
import REDUX_AkkauntiPolzovatelei from '../../../objects/AkkauntiPolzovatelei/reducer';
import greenClock from '../../../green-clock.svg';
import { useMediaQuery } from 'react-responsive';
import SiteAccessDeny from '../../../desktop/pages/SiteAccessDeny';
import { MetaContext } from 'fennec-ui';
import Icofont from 'react-icofont';
import { LangSwitchContext, useLangSwitchContext } from '../../../common/Context';
import LangSwitchMobile from '../../components/LangSwitchMobile';
import REDUX_UserConfig from '../../../objects/UserConfig/reducer'
import REDUX_Translate from '../../../objects/Translate/reducer';
import { LogoutOutlined } from '@ant-design/icons';
import { MaxIcon, translate, ycBucket } from '../../../common/Tool';
import { Dialog } from '../../../common/Dialog';
import YImage from '../../../common/YImage';
import QRCode from 'react-qr-code';
import { Button } from 'antd';

var _ = require('lodash');

const mainDark = "#001529";
const useStyles = createUseStyles({
	tabs: {
		'& .am-tabs-default-bar .am-tabs-default-bar-underline': {
			border: "1px #001529 solid"
		}
	},
})


const SingleEvent = (props) => {
	const classes = useStyles();
	const { event, size } = props;

	const playbillSize = "78px";

	const kategorii = (data) => {
		let result = [];
		let mResult = new Map();
		if (data) {
			for (let idx = 0; idx < data.length; idx++) {
				const item = data[idx];
				let kat = mResult.get(item.tantsevalnayaDistsiplinaID);
				if (!kat) {
					kat = {
						tantsevalnayaDistsiplina: item.tantsevalnayaDistsiplina,
						kategoriiUchastnikov: [],
						mKategoriiUchastnikov: new Map(),
					}
					mResult.set(item.tantsevalnayaDistsiplinaID, kat);
					result.push(kat);
				}
				let ok = kat.mKategoriiUchastnikov.get(item.kategoriyaUchastnikovID);
				if (!ok) {
					kat.mKategoriiUchastnikov.set(item.kategoriyaUchastnikovID, data[idx].kategoriyaUchastnikov)
					kat.kategoriiUchastnikov.push(data[idx].kategoriyaUchastnikov);
				}
			}
		}

		for (let idx = 0; idx < result.length; idx++) {
			result[idx].kategoriiUchastnikov.sort((a, b) => a.ID - b.ID);
		}

		result.sort((a, b) => a.tantsevalnayaDistsiplina.ID - b.tantsevalnayaDistsiplina.ID);

		return result
	}
	const kategoriiView = (e) => {
		const list = kategorii(e.kategoriiUchastnikovNaMeropriyatiyakhMeropriyatie);
		if (list.length <= 0) return <></>;
		return (
			<div key="q4" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
				<div className={classes.fieldName}>Категории:</div>
				<ul style={{ listStyle: "none", paddingInlineStart: "2px", fontSize: "13px" }}>
					{list.map((kat, i) => {
						return <li key={i}>
							{kat.tantsevalnayaDistsiplina.nazvanie + " "}
							({
								kat.kategoriiUchastnikov.map((itemD, idx) => {
									if (idx + 1 < kat.kategoriiUchastnikov.length) {
										return <span key={idx}>{itemD.nazvanie.toLowerCase() + ", "}</span>
									} else {
										return <span key={idx}>{itemD.nazvanie.toLowerCase()}</span>
									}
								})
							})
						</li>
					})}
				</ul>
			</div>
		);
	};
	if (!event) return <></>;
	return (
		<div className="event-block" style={{ display: "flex", justifyContent: "space-between" }}>
			<div style={{ maxWidth: "78px" }}>
				{(size !== "small") && <div style={{ width: playbillSize, height: playbillSize, overflow: "hidden" }}>
					<YImage item={event} width={78} hidePreview={true} />
					{/* <YImage image={e.afisha} minimage={e.afishaMin} width={imgSize} /> */}
				</div>}
				<div style={(size !== "small") ? { marginTop: "7px" } : {}}>
					<div style={{
						backgroundColor: "#eaeaea",
						fontSize: "16px",
						fontWeight: "400",
						color: "black",
						borderRadius: "6px",
						textAlign: "center",
						padding: "0 7px",
						textAlign: "center",
					}}>
						<div style={{
							borderRadius: "5px",
							backgroundColor: "#f6214b",
							fontSize: "12px",
							fontWeight: "600",
							color: "white",
							margin: "0 -7px",
							boxShadow: "0px 6px 5px -5px rgb(34 60 80 / 60%",
							padding: "3px 7px"
						}}>
							{moment(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}
							{/* {true === sameDay(event.nachaloSorevnovaniya, event.okonchanieSorevnovaniya) &&
								moment(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')
							}
							{true !== sameDay(event.nachaloSorevnovaniya, event.okonchanieSorevnovaniya) &&
								<>
									<div style={{ fontSize: "16px" }}>
										{moment(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD')}
										-
										{moment(event.okonchanieSorevnovaniya).tz("Europe/Moscow").format('DD')}
									</div>
									<div style={{ fontSize: "14px" }}>
										{moment(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('MMMM')} {moment(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('YYYY')}
									</div>
								</>
							} */}
						</div>
						<div style={{
							fontSize: "10px",
							fontWeight: "400",
							padding: "0px"
						}}>
							{moment(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
							{/* {true === sameDay(event.nachaloSorevnovaniya, event.okonchanieSorevnovaniya) && <>
								{moment(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
							</>}
							{true !== sameDay(event.nachaloSorevnovaniya, event.okonchanieSorevnovaniya) && <>
								{moment(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
								<span> - </span>
								{moment(event.okonchanieSorevnovaniya).tz("Europe/Moscow").format('dddd')}
							</>} */}
						</div>
					</div>
				</div>
			</div>
			<div style={{ flex: "auto", paddingLeft: "7px", lineHeight: "1.2" }}>
				<div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
					{/* <span className={classes.fieldName}>Название: </span> */}
					<span style={{ fontWeight: "600", fontSize: (size !== "small") ? "14px" : "14px" }}>
						<a href={`/fed/event/${event.ID}`}>{event.nazvanieMeropriyatiya}</a>
					</span>
				</div>
				<div key="q2" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
					<span className={classes.fieldName}>Уровень: </span><span className={classes.fieldValue}>{event.urovenMeropriyatiya.opisanie}</span>
				</div>
				<div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
					<span className={classes.fieldName}>Место проведения: </span>
					<span className={classes.fieldValue}>{event.mestoProvedeniya.name}</span>
				</div>
				{(size !== "small") && kategoriiView(event)}
			</div>
		</div>
	);
}
function Sidebar(props) {
	// const { open, setOpen } = props;
	const { open, menuClose } = props;
	let navigate = useNavigation();
	// const history = useHistory();
	// history.push("/home");
	const auth = useAuth();
	const t = useTranslateContext();
	const user = useUserContext();
	const langSwitch = useLangSwitchContext();
	const [userConfig, setUserConfig] = useUserConfigContext();
	const akkauntiPolzovatelei = useSelector(REDUX_AkkauntiPolzovatelei.selector.array);

	const vkbot = process.env.REACT_APP_VKBOT
	const tgbot = process.env.REACT_APP_TGBOT
	const maxbot = process.env.REACT_APP_MAXBOT

	// useEffect(() => {
	// 	setOpen(false)
	// }, [location.pathname]);

	const logout = () => {
		auth.logout(() => {
			navigate('/');
		});
	}
	const logoutall = (e) => {
		e.stopPropagation();
		e.preventDefault();

		Dialog.confirm({
			content: t('Вы действительно хотите выйти на всех устройствах?'),
			confirmText: t("Выйти"),
			cancelText: t("Отмена"),
			onConfirm: async () => {
				await auth.logoutall(() => {
					navigate('/');
				});
			},
		})
	}

	const [idCard, setIdCard] = useState()
	const loadIdCard = useCallback(() => {
		GET(auth, '/api/idcard', ({ data }) => {
			if (data) {
				setIdCard(data)
			}
		}, (err) => errorCatch(err))
	}, [auth])

	return (
		<Popup
			visible={open}
			// onMaskClick={() => setOpen(false)}
			onMaskClick={menuClose}
			position='right'
			bodyStyle={{ width: '80vw' }}
		>
			<div className='sidebar'>
				<div>
					{user && <div className='user bg bg-grey dark-5' style={{ padding: "4px" }}>
						<Avatar src={(user.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + user.avatarMin : ""} />
						<div className='user-name'>
							<div style={{ overflow: "hidden", textOverflow: "ellipsis", fontSize: "14px" }}>{user.lastname + " " + user.firstname}</div>
							<div style={{ overflow: "hidden", textOverflow: "ellipsis", fontSize: "12px", color: "#9a9a9ab5" }}>{user.email}</div>
						</div>
						<div>
							<Action
								auth={auth}
								action={() => {
								}}
								object={idCard}
								modal={{
									title: "QR-id"
								}}

								readonly={true}
								mode={"func"}
								noAntForm={true}
								form={(props) => {
									const { object } = props;
									return <div style={{ display: "flex", justifyContent: "center", padding: "5px" }}>
										{object &&
											<div>
												<div className='bg bg-transparent' style={{ display: "flex", justifyContent: "space-evenly" }}>
													<Avatar src={(user?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + user?.avatarMin : undefined} />

													<div className='user-name'>
														<div style={{ overflow: "hidden", textOverflow: "ellipsis", fontSize: "14px" }}>{user.lastname + " " + user.firstname}</div>
														<div style={{ overflow: "hidden", textOverflow: "ellipsis", fontSize: "12px", color: "#9a9a9ab5" }}>{user.email}</div>
													</div>
												</div>

												<div style={{ padding: "15px 5px 20px 5px", backgroundColor: "white", borderRadius: "6px", textAlign: "center" }}>
													<QRCode level="M" value={object} />
												</div>

												<div style={{ display: "flex", justifyContent: "center" }}>
													<Button onClick={loadIdCard}>Обновить</Button>
												</div>
											</div>}
									</div>
								}}
								trigger={(click) => (
									<div onClick={event => {
										event.stopPropagation();
										loadIdCard()
										click()
									}}>
										<i className="fa fa-qrcode" style={{ color: "black", fontSize: "42px", margin: "3px 5px 0 0" }}></i>
									</div>
								)}
							/>
						</div>
					</div>}
					<div className='logout bg bg-grey' style={{ padding: "4px", marginTop: "5px" }} onClick={logout}>
						<div>
							<LogoutOutlined />
							<span style={{ paddingLeft: "5px" }}> {t("Выход")}</span>
						</div>
						<div style={{ flex: 0, color: "red" }} onClick={logoutall}>
							<Icofont icon="logout" />
						</div>
					</div>
				</div>
				<div>
					{langSwitch}
				</div>
				<div>
					<div style={{ padding: "5px 0px", display: "flex", alignItems: "center", gap: "5px" }}>
						<div style={{ flex: "1 1 50%" }}>
							<a target="_blank" rel="noreferrer" href={(tgbot) ? 'https://t.me/' + tgbot : "#"}>
								<div className={`bg bg-grey light-10 pointer ${(user && user.tgchatid) ? "border-green" : "border-red"}`} style={{ justifyContent: "center", padding: "2px 4px", display: "flex", gap: "5px", alignItems: "center" }}>
									<div><i className="fa fa-telegram" style={{ fontSize: "14px" }}></i></div>
									<div style={{ fontSize: "12px", color: "rgba(0, 0, 0, 0.85)" }}>
										{(user && !user.tgchatid) && <div>Telegram</div>}
										{(user && user.tgchatid) && <div>Telegram</div>}
									</div>
								</div>
							</a>
						</div>
						<div style={{ flex: "1 1 50%" }}>
							<a target="_blank" rel="noreferrer" href={(vkbot) ? 'https://vk.com/im?sel=-' + vkbot : "#"}>
								<div className={`bg bg-grey light-10 pointer ${(user && user.vk) ? "border-green" : "border-red"}`} style={{ justifyContent: "center", padding: "2px 4px", display: "flex", gap: "5px", alignItems: "center" }}>
									<div><i className="fa fa-vk" style={{ fontSize: "14px" }}></i></div>
									<div style={{ fontSize: "12px", color: "rgba(0, 0, 0, 0.85)" }}>
										{(user && !user.vk) && <div>VK</div>}
										{(user && user.vk) && <div>VK</div>}
									</div>
								</div>
							</a>
						</div>
						<div style={{ flex: "1 1 50%" }}>
							<a target="_blank" rel="noreferrer" href={(maxbot) ? 'https://max.ru/' + maxbot : "#"}>
								<div className={`bg bg-grey light-10 pointer ${(user && user.maxchatid) ? "border-green" : "border-red"}`} style={{ justifyContent: "center", padding: "2px 4px", display: "flex", gap: "5px", alignItems: "center" }}>
									<div><MaxIcon width={14} height={14} color="#4096ff" /></div>
									<div style={{ fontSize: "12px", color: "rgba(0, 0, 0, 0.85)" }}>
										{(user && !user.maxchatid) && <div>Max</div>}
										{(user && user.maxchatid) && <div>Max</div>}
									</div>
								</div>
							</a>
						</div>
					</div>
				</div>
				<div>
					{!!akkauntiPolzovatelei && <div className="bg bg-grey" style={{ padding: "5px 10px", textAlign: "left", marginBottom: "5px" }}>
						<div>Баланс:</div>
						{akkauntiPolzovatelei.map((e, idx) => <div key={idx} style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", fontSize: "13px" }}>
							<div>
								№{e.akkaunt.nomerAkkaunta}
							</div>
							<div style={{ flex: "auto", textAlign: "end", paddingLeft: "15px", color: (e.akkaunt.ostatok > 0) ? "green" : "red" }}>
								{Number(e.akkaunt.ostatok.toFixed(2)).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
							</div>
						</div>)}
					</div>}
					<div style={{ padding: "0px 0px" }}>
						<List>
							<List.Item
								prefix={<i className="fa fa-globe" style={{ paddingRight: "4px", color: "blue" }}></i>}
								className={"bg-blue"}>
								<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/fed/events`}>
									{t("Главный сайт")}
								</a>
							</List.Item>
							<List.Item
								prefix={<Icofont icon="home" style={{ fontSize: "13px", color: "orange" }} />}
								className={"bg-orange"}>
								<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app`}>
									{t("Личный кабинет")}
								</a>
							</List.Item>
							<List.Item
								prefix={<Icofont icon="ui-calendar" style={{ fontSize: "13px", color: "green" }} />}
								className={"bg-green"}>
								<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/switch`}>
									{t("Войти в мероприятие")}
								</a>
							</List.Item>
							<List.Item
								prefix={<Icofont icon="user" style={{ fontSize: "13px" }} />}>
								<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://auth.${auth.getDomainWithoutSubdomain(window.location.href)}/common/profile`}>
									{t("Профиль")}
								</a>
							</List.Item>
						</List>
					</div>
				</div>
			</div>
		</Popup>
	);
}
function Payment(props) {
	let navigate = useNavigation();
	let { id } = useParams();
	const auth = useAuth();
	const dispatch = useDispatch();
	const userConfig = useSelector(REDUX_UserConfig.selector.object) || {};
	const translates = useSelector(REDUX_Translate.selector.object);
	const maxbot = process.env.REACT_APP_MAXBOT
	const [language, setLanguage] = useState({ lang: (auth.getCookie("lang") || "ru") })
	const t = React.useMemo(() => _.bind(translate, {
		translate: translates,
		config: language
	}), [translates, language]);
	// const t = useTranslateContext();
	// console.log(t("да"));
	const setUserConfig = (name, value, onChange) => {
		POST(auth, "/api/setuserconfig", {
			key: name,
			value: value
		}, ({ data }) => {
			var arr = [data];
			var obj = Object.fromEntries(arr.map(i => {
				return [
					i.key,
					i.value
				]
			}));
			let i = { ...userConfig, ...obj };
			let o = REDUX_UserConfig.actions.setObject(i);
			dispatch(o);
			if (onChange) {
				onChange(i);
			}
		}, errorCatch);
	};

	const meta = useSelector(state => state.meta);
	const user = useSelector(state => state.home.user);
	const siteAccess = useSelector(state => state.siteAccess.value);

	const [online, setOnline] = useState(false);
	const [loading, setLoading] = useState(false);

	// const [cart, setCart] = useState(undefined);
	const [event, setEvent] = useState(undefined);


	useEffect(
		() => {
			auth.fetch('/api/meta').then(res => {
				if (res && res.data && dispatch) {
					dispatch({ type: 'META', payload: res.data })
				}
			});
			auth.fetch('/api/iam').then(res => {
				if (res && res.data) {
					dispatch({ type: 'USER', payload: res.data })
				}
			});
			READWITH(auth, 'Translate', [
				QueryDetail("model")
			], ({ data }) => {
				if (data.length > 0) {
					let o = Object.fromEntries(data.map(i => {
						return [
							i.key,
							{
								ru: i.ru,
								en: i.en,
								es: i.es,
								tr: i.tr,
							},
						]
					}));
					dispatch(REDUX_Translate.actions.setObject(o));
				}
			}, errorCatch)
			READWITH(auth, 'UserConfig', [
				QueryDetail("model")
			], ({ data }) => {
				if (data.length > 0) {
					var obj = Object.fromEntries(data.map(i => {
						return [
							i.key,
							i.value
						]
					}));
					dispatch(REDUX_UserConfig.actions.setObject(obj));
				}
			}, errorCatch)
			CRUDE_VseTipiPolzovatelei.read(auth, (data) => {
				if (data.length > 0) {
					dispatch({ type: 'ROLE', payload: data });
				}
			}, 'model', 's-id=ASC');
			GET(auth, "/api/meropriyatiya/list/com?detail=model&w-id=" + id,
				({ data }) => {
					if (data && data.length) {
						setEvent(data[0]);
					}
				}, errorCatch);
			RefreshAkkaunti();
			auth.openSocket("/ws/service", "service",
				function (type, payload) {
					if (type === "reload") {
						window.location.href = window.location.href;
					}
					switch (type) {
						case "siteaccess":
							dispatch({ type: "SITE_ACCESS", payload: payload });
							break;
						case "AkkauntiPolzovatelei":
							dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray([payload]));
							break;
						case "NeedUpdateAkkauntPolzovatelya":
							RefreshAkkaunti();
							break;
						default:
							break;
					}
				},
				//onopen
				function () {
					setOnline(true);
				},
				//onclose
				function () {
					setOnline(false);
				}
			);
			return () => {
				auth.closeSocket("service");
			};
		}, []);

	const _RefreshAkkaunti = () => {
		READWITH(auth, "AkkauntiPolzovatelei", [
			QueryDetail("model")
		], ({ data }) => {
			if (data) {
				dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray(data));
			}
		}, errorCatch);
	};
	var RefreshAkkaunti = _.throttle(_RefreshAkkaunti, 3000, { 'trailing': false });


	// const [open, setOpen] = useState(false);
	// const onOpenChange = () => {
	// 	setOpen(!open);
	// }

	const stack = [];
	const getStack = React.useCallback(() => {
		return stack;
	}, []);

	const [open, setOpen] = useState(false);
	const menuClose = () => {
		if (open) {
			window.history.back();
		}
	}
	const onOpenChange = () => {
		if (!open) {
			pushStateHistoryModal(setOpen, getStack);
			setOpen(true);
			return
		}
		menuClose();
	}

	const actionFunc = React.useMemo(() => (values, unlock) => {
		// console.log("Final Action", values);
		setLoading(true);
		GET(auth, `/api/zakaz/payment/${id}?price=${(values.payment.byCard) ? values.payment.byCard : 0}`,
			(res) => {
				if (res.SuccessUrl) {
					navigate(res.SuccessUrl);
				} else if (res.PaymentUrl) {
					window.location.href = res.PaymentUrl;
				}
				unlock();
				setLoading(false);
			}, (err) => errorCatch(err, () => { setLoading(false); unlock(); }));
	}, []);
	const steps = React.useMemo(() => ([
		{
			key: "cart",
			name: "Шаг 1",
			event: event,
			action: (values, unlock, close) => {
				GET(auth, `/api/zakaz/opened/${event.ID}`, (res) => {
					close(res);
				}, (err) => errorCatch(err, unlock));
			},
			form: PaymentForm
		},
		{
			key: "payment",
			name: "Шаг 2",
			event: event,
			form: PaymentPreview,
		}
	]), [event]);
	const headerRef = useRef(null);
	const isPortrait = useMediaQuery({ orientation: 'portrait' })
	const [windowInnerHeight, setWindowInnerHeight] = useState(window.innerHeight)
	useEffect(() => {
		setWindowInnerHeight(window.innerHeight)
	}, [isPortrait]);
	return (
		<TranslateContext.Provider value={t}>
			<MetaContext.Provider value={meta}>
				<UserContext.Provider value={user}>
					<UserConfigContext.Provider value={[userConfig, setUserConfig]}>
						<LanguageContext.Provider value={[language, setLanguage]}>
							<LangSwitchContext.Provider value={<LangSwitchMobile userConfig={userConfig} />}>
								<div className='app'>
									<div className='header' style={{ display: "flex", justifyContent: "space-between", backgroundColor: mainDark }}>
										<NavLink to="/fed/events">
											<div style={{ flex: 0 }}>
												<div className="logo-mobile" />
											</div>
										</NavLink>
										<div style={{ flex: 0 }}>
											<div className='sider-button'>
												<Icofont key="1" icon="navigation-menu" onClick={onOpenChange} />
											</div>
										</div>
									</div>
									<div className='content'>
										{/* <Sidebar open={open} setOpen={setOpen} /> */}
										<Sidebar open={open} menuClose={menuClose} getStack={getStack} />
										<div className='page'>
											<div>
												{(!siteAccess || siteAccess === "allow") && <div>
													{(!event?.ID || !user?.ID) && <div style={{
														width: "100%",
														minHeight: "150px",
														display: "flex",
														justifyContent: "center",
														alignItems: "center"
													}}>
														<SpinLoading style={{ '--size': '32px' }} />
													</div>}
													{(event?.ID === 861 && user?.ID && !user?.maxchatid) && <div className="py-8 px-6">
														<div>
															<div style={{ fontSize: "20px", textAlign: "center", paddingBottom: "20px" }}>
																<div style={{ fontWeight: "600" }}>
																	Для покупки подписки на Max-канал (видео Федерации) необходимо связать аккаунт в личном кабинете с аккаунтом в Max.
																</div>
																<div>
																	После связывания аккаунтов зайдите заново на страницу покупки подписки.
																</div>

															</div>
															<div style={{ display: "flex", gap: "20px", justifyContent: "center", alignItems: "center" }}>
																{(user) && <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
																	<div><img src='/resources/logo.png'></img></div>
																	<div>
																		<div>{user.lastname} {user.firstname}</div>
																		<div>{user.email}</div>
																	</div>
																</div>}
															</div>

															<div style={{ display: "flex", justifyContent: "center", gap: "15px", paddingTop: "20px" }}>
																<div style={{ paddingBottom: "20px", display: "flex", flexDirection: "column", gap: "10px" }}>
																	<div style={{ display: "flex", gap: "10px" }}>
																		<a target="_blank" href={(maxbot) ? 'https://max.ru/' + maxbot : "#"}>
																			<div className={`bg bg-grey light-10 pointer border-red`} style={{ padding: "5px 10px", display: "flex", gap: "10px", alignItems: "center", maxWidth: "300px" }}>
																				<div><MaxIcon width={22} height={22} color="#4096ff" /></div>
																				<div style={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.85)" }}>
																					<div>Связать аккаунт c Max</div>
																				</div>
																			</div>
																		</a>
																	</div>
																</div>
															</div>
														</div>
													</div>}
													{((event?.ID && event?.ID !== 861) || user?.maxchatid) && <div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column", padding: "10px" }}>

														<div style={{ paddingBottom: "15px" }}>
															<SingleEvent auth={auth} event={event} size="small" />
														</div>

														{!!loading && <div style={{
															width: "100%",
															minHeight: "150px",
															display: "flex",
															justifyContent: "center",
															alignItems: "center"
														}}>
															<SpinLoading style={{ '--size': '32px' }} />
														</div>}
														{event && <>
															{IfElse(
																!moment(event.okonchanieSorevnovaniya).isBefore(moment()),
																(<div>
																	<div ref={headerRef}>
																		{/* <div ref={headerRef} style={{ height: `calc(100vh - ${(headerRef.current) ? cumulativeOffset(headerRef.current).top : 0}px - 125px)`, overflow: "scroll" }}> */}
																		{event && <Action
																			mode={"inline"}
																			auth={auth}
																			nextText="Подтвердить заказ"
																			okText="Оплатить"
																			action={actionFunc}
																			steps={steps}
																			formWraperStyle={{
																				// paddingBottom: "75px"
																			}}
																		/>}
																	</div>
																</div>),
																(<div style={{ fontSize: "20px", textAlign: "center" }}>

																	<Result
																		img={<img src={greenClock} className="spe am-icon" style={{ width: "60px", height: "60px" }} alt="" />}
																		title="Мероприятие завершено"
																		message="Билеты на это мероприятие больше не доступны"
																	/>
																</div>))}
														</>}
													</div>}
												</div>}
												{(siteAccess === "deny") && <SiteAccessDeny {...props} />}
											</div>
										</div>
									</div>
									<div className={"footer"}>
										{/* {footer} */}
										{/* <TabBar
										safeArea={true}
										activeKey={location.pathname}
										onChange={value => navigate(value)}>
										<TabBar.Item
											key={"/protocol"}
											icon={<Icofont icon="list" style={{ fontSize: '24px' }} />}
											title={t("Протокол")}
										/>
										<TabBar.Item
											key={"/judge"}
											icon={<Icofont icon="user-alt-7" style={{ fontSize: '24px' }} />}
											title={t("Судья")}
										/>
									</TabBar> */}
									</div>
								</div>

							</LangSwitchContext.Provider>
						</LanguageContext.Provider>
					</UserConfigContext.Provider>
				</UserContext.Provider>
			</MetaContext.Provider>
		</TranslateContext.Provider >
	);
};

export default Payment;